// CSS variables change the rendered palette without remounting forms or jobs.
const roles = new Set(['bg','surface','card','cardAlt','cardHover','border','borderDark','borderSoft','nav','navBorder','navText','gold','goldText','red','redText','green','greenText','amber','amberText','blue','blueText','purple','purpleText','text','textMid','textDim','shadow','shadowMd']);
export function themePalette(palette) {
  return Object.fromEntries(Object.entries(palette).map(([key, value]) => [key, roles.has(key) ? `var(--app-${key}, ${value})` : value]));
}
export const THEME_KEY = 'jmf_appearance';
export function readThemePreference() {
  try { const value = localStorage.getItem(THEME_KEY); return ['light','dark','system'].includes(value) ? value : 'dark'; } catch { return 'dark'; }
}
export function resolveTheme(preference) {
  return preference === 'system' ? (window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light') : preference;
}
export function applyTheme(preference) {
  const resolved = resolveTheme(preference);
  document.documentElement.dataset.theme = resolved;
  document.documentElement.style.colorScheme = resolved;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', resolved === 'light' ? '#F3F5F7' : '#101820');
  return resolved;
}
